import { AccountType, Condominium, Device, DeviceType, StorageKeys, DeviceCache, IceMode } from '../../models/models'
import { HttpClient, HttpParams } from '@angular/common/http'

import { AuthProvider } from '../auth/auth'
import { ConfigProvider } from '../../providers/config/config'
import { DomainEvents } from '../../models/models'
import { Events } from 'ionic-angular'
import { Injectable } from '@angular/core'
import { Device as NativeDevice } from '@ionic-native/device'
import { Platform } from 'ionic-angular'
import { Storage } from '@ionic/storage'
import { UniqueDeviceID } from '@ionic-native/unique-device-id'
import { Network } from '@ionic-native/network'


import { AndroidFullScreen } from '@ionic-native/android-full-screen'
import { Autostart } from '@ionic-native/autostart'
//import { BackgroundMode } from '@ionic-native/background-mode';
//import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import { Insomnia } from '@ionic-native/insomnia'
//import { LocalNotifications } from '@ionic-native/local-notifications';
import { NavigationBar } from '@ionic-native/navigation-bar'
import { ScreenOrientation } from '@ionic-native/screen-orientation'
//import { TextToSpeech } from '@ionic-native/text-to-speech';
import { AndroidPermissions } from '@ionic-native/android-permissions'
import { SignalingSocketIoProvider } from '../../providers/signaling/socket_io'
import { AndroidBridgeProvider } from '../android/android-bridge'

//import { WebIntent, IntentOptions } from '@ionic-native/web-intent';

//import { WebrtcProvider } from '../webrtc/webrtc';
//supporto per i plugin cordova
declare var window: any

@Injectable()
export class DeviceProvider {
	/**
	Configurazione del dispositivo attualmente connesso
	*/
	private static _actual: Device = null;
	/**
	Strategia di selezione degli ICE servers
	*/
	private _iceMode: IceMode = null;//default
	/**
	Configurazione del dispositivo attualmente connesso
	*/
	private static _iceServers:{ urls: string; credential?: string; username?: string; }[] = ConfigProvider.RTC_PEER_ICE_SERVERS_PRIVATE;//default

	private refreshActualInterval: number = null;

	public appName: string = null;
	/**
	Package name
	*/
	public appPackageName: string = null;
	/**
	Version number
	*/
	public appVersionNumber: string = null;
	/**
	Build identifier
	*/
	public appVersionCode: string = null;

	/**
	Identificativo dispositivo corrente
	*/
	public static identifier: string = null;


	public static get iceServers(): any[] {
		return DeviceProvider._iceServers
	}


	private _isAlwaysFront: boolean = false;
	public get isAlwaysFront(): boolean {
		return this._isAlwaysFront
	}


	public get isBackgroundModeEnabled(): boolean {
		if(!this.plugins.backgroundMode) {
			return null
		}

		return this.plugins.backgroundMode.isEnabled()
	}




	/**
	Decide dinamicamente se il dispositivo attuale è un browser, in base alla disponibilità di cordova
	*/
	public get isBrowser(): boolean {
		return !this.isCordova
	}

	/**
	Decide se l'applicativo è su un dispositivo nativo con funzioni native disponibili via cordova
	*/
	public get isCordova(): boolean {
		return this.platform.is('cordova')
	}



	private _isDebugMode: boolean = null;
	/**
	Verifica se l'installazione corrente è in modo sviluppo
	*/
	public get isDebugMode(): boolean {
		return this._isDebugMode
	}


	/**
	Verifica se il dispositivo corrente è stato configurato per la modalità sviluppo
	*/
	public get isDevelopmentMode() {
		return DeviceProvider.actual && DeviceProvider.actual.is_development_mode
	}



	private _isFullScreen: boolean = false;
	public get isFullScreen(): boolean {
		return this._isFullScreen
	}


	public get isInBackground(): boolean {
		if(!this.plugins.backgroundMode) {
			return null
		}

		return this.plugins.backgroundMode.isActive()
	}



	public _isKeepawake: boolean = false;
	public get isKeepawake() {
		return this._isKeepawake
	}




	private _isKiosk: boolean = false;
	public get isKiosk(): boolean {
		return this._isKiosk
	}

	public _isLanscape: boolean = false;
	public get isLanscape(): boolean {
		return this._isLanscape
	}

	private _isNavigationBarAutohiding: boolean = false;
	public get isNavigationBarAutohiding(): boolean {
		return this._isNavigationBarAutohiding
	};


	/**
	Flag connessione internet presente
	*/
	public get isNetworkConnected(): boolean {
		if(this.isBrowser) {
			//Usa signaling per controllare lo stato di connessione nel browser perchè il plugin cordova non è disponibile
			return this.signaling.isOnline
		}
		return this.network.type !== 'none'
	};


	public _isPortrait: boolean = false;
	public get isPortrait(): boolean {
		return this._isPortrait
	}


	/**
	Modalità input audio supportata dal dispositivo
	*/
	public isAudioInputSupported: boolean = false;

	public isCallNumberAvailable: boolean = false;

	/**
	Modalità input video supportata dal dispositivo
	*/
	public isVideoInputSupported: boolean = false;
	/**
	Modalità output audio supportata dal dispositivo
	*/
	public isAudioOutputSupported: boolean = false;


	private lastNetworkType: string = null;

	/**
	Dispositivo attuale, viene valorizzato soltanto se è anche salvato in DB

	NOTE è statico per evitare il problema dei riferimenti incrociati in fase di inizializzazione
	*/
	public static get actual(): Device {
		return DeviceProvider._actual
	}
	/**
	Imposta il dispositivo attuale, quindi aggiorna il tipo attuale

	NOTE è statico per evitare il problema dei riferimenti incrociati in fase di inizializzazione
	*/
	/*
	public static set actual(value: Device) {
	//this.disableActualPolling()//lo toglie o lo sostituisce, quindi comunque prima lo rimuove ed evita rischi di sovrascrittura
	DeviceProvider._actual = value;
	if (value) {
	DeviceProvider.singleton.actualType = value.type;
	//this.enableActualPolling()
} else {
DeviceProvider.singleton.actualType = null;
}
}
*/

	/*
	Modalità di funzionamento di questo dispositivo, tra: intercom smartphone  dashboard.
	Se configurato in remoto la recupera da remoto, altrimenti produce un default.
	Può essere valorizzata senza generare una configurazione remota.
	*/
	private static _actualType: DeviceType = null;

	private static _actualIdentifier: string = null;

	//private appForegroundCheckerInterval: any = null;

	private static _audioContext: AudioContext = null;
	/**
	Singleton di AudioContext, istanziato in modo lazy
	*/
	public static get audioContext(): AudioContext {
		if(!DeviceProvider._audioContext) {
			DeviceProvider._audioContext = new AudioContext()
		}
		return (DeviceProvider._audioContext)
	}


	/**
	Recupera la modalità di selezione degli ICE server per il dispositivo corrente.

	Se non ha configurazione restituisce AUTO
	*/
	public get iceMode(): IceMode {
		let actual = DeviceProvider.actual
		return actual && actual.ice_mode ? actual.ice_mode : IceMode.AUTO
	}


	/**
	Restituisce il dispositivo attuale, se configurato usa quello, altrimenti lo "indovina" usando guessType()

	NOTE: L'accesso non è statico perchè deve avere this.events a disposizione quando deve propagarne l'aggiornamento
	*/
	public get actualType(): DeviceType {
		let type = DeviceProvider._actualType
		if(type === null) {
			type = this.guessType()//default - non lo salva per poter distinguere se lo ha indovinato o è esplicito
		}
		return type
	}

	/**
	Inizializza _iceServers in base al valore di _actual
	*/
	public async initIceServers(): Promise<any[]> {

		let previousMode: IceMode = this._iceMode
		let actual = DeviceProvider.actual
		let iceMode = actual ? actual.ice_mode : IceMode.AUTO
		console.debug('[DeviceProvider.initIceServers()] Modo ' + iceMode + ' per scegliere i server ICE per la connessione webrtc')
		if(iceMode == previousMode) {
			return Promise.resolve(DeviceProvider._iceServers)
		}

		switch(iceMode) {
			default:
			case IceMode.AUTO:
				console.debug('[DeviceProvider.iniIceServers()] Uso server ICE privati:',ConfigProvider.RTC_PEER_ICE_SERVERS_PRIVATE)
				return DeviceProvider._iceServers=ConfigProvider.RTC_PEER_ICE_SERVERS_PRIVATE
			case IceMode.PUBLIC:
				//configurazione invariata
				console.debug('[DeviceProvider.initIceServers()] Uso server ICE pubblici:', ConfigProvider.RTC_PEER_ICE_SERVERS_PUBLIC)
				return DeviceProvider._iceServers = ConfigProvider.RTC_PEER_ICE_SERVERS_PUBLIC
			case IceMode.PUBLIC_STUN:
				let iceServers = ConfigProvider.RTC_PEER_ICE_SERVERS_PUBLIC
				let stunServers = []
				//usa i soli server STUN della configurazione di default
				for(let i = 0; i < iceServers.length; i++) {
					let server = iceServers[i]
					if(server.urls && server.urls.toLowerCase().startsWith('stun')) {
						stunServers.push(server)
					}
				}
				console.debug('[DeviceProvider.initIceServers()] Uso server STUN (no TURN) pubblici:', stunServers)
				return DeviceProvider._iceServers = stunServers
			case IceMode.XIRSYS://recupera i server xirsys, li imposta e si connette
				console.debug('[DeviceProvider.initIceServers()] Recupero server ICE da Xirsys..')
				return new Promise<any>((resolve, _) => {
					let xhr = new XMLHttpRequest()
					xhr.onreadystatechange = _ => {
						if(xhr.readyState == 4) {
							if(xhr.status == 200) {
								let result = JSON.parse(xhr.responseText)
								if(result.s == 'ok') {
									console.debug("[DeviceProvider.initIceServers()] Ricevuti ICE servers da Xirsys: ", result.v.iceServers)
									DeviceProvider._iceServers = [result.v.iceServers]
									resolve(DeviceProvider._iceServers)
								}
							} else {
								console.warn('[DeviceProvider.initIceServers()] Errore recuperanto i server ICE da Xirsys', xhr)
								console.debug('[DeviceProvider.initIceServers()] Uso i server pubblici come fallback:', ConfigProvider.RTC_PEER_ICE_SERVERS_PUBLIC)
								DeviceProvider._iceServers = ConfigProvider.RTC_PEER_ICE_SERVERS_PUBLIC
								resolve(DeviceProvider._iceServers)
								//reject('Impossibile recuperare i server Xirsys per la connessione audio/video');
							}
						}
					}
					xhr.open("PUT", "https://global.xirsys.net/_turn/IDesk", true)
					xhr.setRequestHeader("Authorization", "Basic " + btoa("luke:9a8d2722-8384-11e9-a220-0242ac110003"))
					xhr.setRequestHeader("Content-Type", "application/json")
					xhr.send(JSON.stringify({ "format": "urls" }))
				})
		}
	}

	public get platformId(): string {
		if(!window.cordova) {
			return null
		}
		return window.cordova.platformId
	}
	public get platformVersion(): string {
		if(!window.cordova) {
			return null
		}
		return window.cordova.platformVersion
	}

	/**
	Plugin cordova allineati in unico oggetto
	*/
	private plugins: any = {};

	private static _singleton: DeviceProvider = null;
	public static get singleton(): DeviceProvider {
		return DeviceProvider._singleton
	}

	constructor(
		public androidFullScreen: AndroidFullScreen,
		public androidPermissions: AndroidPermissions,
		private androidBridge: AndroidBridgeProvider,
		public autostart: Autostart,
		public auth: AuthProvider,
		public device: NativeDevice,
		private events: Events,
		private http: HttpClient,
		public insomnia: Insomnia,
		public navigationBar: NavigationBar,
		private network: Network,
		private platform: Platform,
		public screenOrientation: ScreenOrientation,
		private signaling: SignalingSocketIoProvider,
		private storage: Storage,
		private uniqueDeviceID: UniqueDeviceID,
		//private intents: WebIntent
	) {
		if(DeviceProvider._singleton) {
			console.warn('Trovato singleton di DeviceProvider già istanziato, servizio istanziato due volte')
		} else {
			DeviceProvider._singleton = this
			console.debug('Singleton salvato')
		}

		let self = this

		platform.ready().then(type => {
			console.group('[DeviceProvider.platform.ready()] Inizializzazione delle funzioni native del dispositivo..', type)

			this.events.subscribe(DomainEvents.ANDROID_MESSAGE_RECEIVED, (msg: any) => {
				console.group('[DeviceProvider] ANDROID_MESSAGE_RECEIVED Ricevuto un messaggio di tipo "'+msg.action+'" dal bridge android', msg);
				switch (msg.action) {
					case 'impuls':
					case 'get_id':
					case 'call':
					case 'close_app':
					default:
						console.debug('[DeviceProvider] Contenuto: '+msg.content)
						// inoltra/ignora/logga
						break;
				}
				console.groupEnd();
			});

			if(self.isBrowser) {//browser: Il plugin network non funziona
				self.signaling.onOnline.attach(() => {
					console.debug('[DeviceProvider.signaling.onOnline()] Browser offline')
				})
				self.signaling.onOffline.attach(() => {
					console.debug('[DeviceProvider.signaling.onOffline()] Browser online')
				})
			} else {
				self.network.onConnect().subscribe(() => {
					console.group('[DeviceProvider.network.onConnect()] App online, tipo di connessione immediato: ' + self.network.type)

					if(self.lastNetworkType !== self.network.type) {//cambio connessione o connessione dopo disconnessione
						console.debug('Tipo di rete modificato o nuova connessione')
						//reimposta la sessione su signaling per bypassare errore connect/disconnect
						self.signaling.reconnect()

						// We just got a connection but we need to wait briefly before we determine the connection type.
						// Might need to wait prior to doing any api requests as well.
						setTimeout(() => {
							console.debug('[ClientApp.network.onConnect()] App online, tipo di connessione dopo il timeout: ' + self.network.type)

							//The type property will return one of the following connection types: unknown, ethernet, wifi, 2g, 3g, 4g, cellular, none
							switch(self.network.type) {
								case 'unknown':
								case 'ethernet':
								case 'wifi':
								case '2g':
								case '3g':
								case '4g':
								case 'cellular':
								default:
									break
								case 'none':
									break
							}
						}, 3000)
					}

					self.lastNetworkType = self.network.type

					console.groupEnd()
				})
				self.network.onDisconnect().subscribe(() => {
					console.debug('[DeviceProvider.network.onDisconnect()] App offline')
					self.lastNetworkType = null
				})
			}

			if(window.appContext) {
				console.warn('Inizializzazione dei plugin cordova avvenuta due volte!')
			} else {
				window.appContext = {
					plugins: {},
					isCordova: this.platform.is('cordova')
				}
			}

			if(window.appContext.isCordova) {
				console.info("DeviceProvider.platform.ready() : Registrazione dei plugin nativi..")
				/*
				REGISTRAZIONE PLUGINS IN this.plugins[] e window.appContext.plugins
				*/


				/*
				Plugins in window.cordova e window.cordova.plugins
				*/
				if(window.cordova) {
					//console.debug('DeviceProvider.platform.ready() : Cordova disponibile', window.cordova)

					for(let pluginName in window.cordova.plugins) {
						window.appContext.plugins[pluginName] = self.plugins[pluginName] = window.cordova.plugins[pluginName]
					}

					if(window.cordova.getAppVersion) {
						window.appContext.plugins.getAppVersion = self.plugins.getAppVersion = window.cordova.getAppVersion
					}
				} else {
					console.warn('Variabile window.cordova non disponibile su app')
				}

				/**
				Plugin in window.plugins
				*/
				if(window.plugins) {
					//console.debug('DeviceProvider.platform.ready() : Plugin cordova disponibili in window.plugins:', window.plugins)

					for(let pluginName in window.plugins) {
						console.debug("[DeviceProvider.platform.ready()] Trovato plugin cordova: " + pluginName)
						window.appContext.plugins[pluginName] = self.plugins[pluginName] = window.plugins[pluginName]
					}
				} else {
					console.warn('[DeviceProvider.platform.ready()] Variabile window.plugins non disponibile su app')
				}

				console.info('[DeviceProvider.platform.ready()] Plugins cordova individuati e registrati:', self.plugins)


				/*
				INIZIALIZZAZIONE PLUGIN
				*/

				/* IS DEBUG */
				if(self.plugins.IsDebug) {
					self.plugins.IsDebug.getIsDebug(isDebug => {
						self._isDebugMode = isDebug
					}, e => {
						console.error('Errore usando il plugin cordova IsDebug', e)
					})
				}

				/*
				getAppVersion
				*/
				if(self.plugins.getAppVersion) {
					let getAppVersion = self.plugins.getAppVersion
					try {
						getAppVersion.getAppName().then((appName) => {
							window.appContext.appName = self.appName = appName
						})
						getAppVersion.getVersionNumber().then((appVersionNumber) => {
							window.appContext.appVersionNumber = self.appVersionNumber = appVersionNumber
						})//Returns the version number of the app
						getAppVersion.getVersionCode().then((appVersionCode) => {
							window.appContext.appVersionCode = self.appVersionCode = appVersionCode
						})//build identifier
						getAppVersion.getPackageName().then((appPackageName) => {
							window.appContext.appPackageName = self.appPackageName = appPackageName
						})
					} catch(e) {
						console.error('Errore accedendo al plugin getAppVersion', e)
					}
				} else {
					console.warn('Cordova plugin getAppVersion non inizializzato')
				}


				window.appContext.platformId = window.cordova.platformId
				window.appContext.platformVersion = window.cordova.platformVersion


				/*
				CallNumber
				*/
				if(self.plugins.CallNumber) {
					if(self.plugins.CallNumber.isCallSupported) {
						self.plugins.CallNumber.isCallSupported((result) => {
							console.debug('DeviceProvider.platform.ready() : Esito controllo disponibilità chiamate in uscita: ' + result, result)
							self.isCallNumberAvailable = result
							window.appContext.isCallNumberAvailable = result
						})
					} else {
						console.warn('CallNumber.isCallSupported non disponibile')
						self.isCallNumberAvailable = true
					}
				}

				/*
				Background mode
				*/
				if(self.plugins.backgroundMode) {
					console.info("DeviceProvider.platform.ready() : Configurazione della gestione attività in background..")

					//attiva e disattiva a login e logout
					self.events.subscribe(DomainEvents.USER_LOGIN, user => {
						console.group('[DeviceProvider.events.on(USER_LOGIN)] Ricevuta notifica di login', user)
						self.adaptBehaviour()
						console.groupEnd()
					})

					self.events.subscribe(DomainEvents.USER_LOGOUT, user => {
						console.group('[DeviceProvider.events.on(USER_LOGOUT)] Ricevuta notifica di logout', user)
						self.adaptBehaviour()
						console.groupEnd()
					})


					self.plugins.backgroundMode.on('enable', () => {
						console.debug("[DeviceProvider.plugins.backgroundMode.on('enable')] Background persistente abilitato")
					})
					self.plugins.backgroundMode.on('disable', () => {
						console.debug("[DeviceProvider.plugins.backgroundMode.on('disable')] Background persistente disabilitato")
					})


					self.plugins.backgroundMode.on('activate', () => {
						console.debug("[DeviceProvider.plugins.backgroundMode.on('activate')] App in background")
						if(self.isAlwaysFront) {
							console.debug('[DeviceProvider.plugins.backgroundMode.on(\'activate\')] "sempre in primo piano" attivo, riporto in primo piano..')
							self.moveToForeground()
						}
					})
					self.plugins.backgroundMode.on('deactivate', () => {
						console.debug("[DeviceProvider.plugins.backgroundMode.on('deactivate')] App in primo piano")
					})

					self.plugins.backgroundMode.on('failure', (error) => {
						console.error("[DeviceProvider.plugins.backgroundMode.on('failure')] Errore gestendo il background persistente", error)
					})

					//non lo visualizza nell'elenco task
					console.debug("[DeviceProvider.platform.ready()] Escludo l'app dalla lista dei task..")
					self.plugins.backgroundMode.excludeFromTaskList()

					//sempre attivo tramite notifica
					console.debug("[DeviceProvider.platform.ready()] Imposto la notifica di persistenza in background..")
					/*
					The title, text and icon for that notification can be customized as below. Also, by default the app will come to foreground when tapping on the notification. That can be changed by setting resume to false. On Android 5.0+, the color option will set the background color of the notification circle. Also on Android 5.0+, setting hidden to false will make the notification visible on lockscreen.

					cordova.plugins.backgroundMode.setDefaults({
					title: String,
					text: String,
					icon: 'icon' // this will look for icon.png in platforms/android/res/drawable|mipmap
					color: String // hex format like 'F14F4D'
					resume: Boolean,
					hidden: Boolean,
					bigText: Boolean				})

					To modify the currently displayed notification

					cordova.plugins.backgroundMode.configure({ ... });
					*/
					let backgroundNotification = {
						title: ConfigProvider.APPLICATION_NAME,
						text: 'Eta Desk: Citofono virtuale',
						resume: true,//in primo piano al click
						hidden: false,//notifica visibile a schermo bloccato
					}
					self.plugins.backgroundMode.setDefaults(backgroundNotification)
					self.plugins.backgroundMode.configure(backgroundNotification)
					//Si attiva quando fa login o quando è sempre in primo piano
					//self.plugins.backgroundMode.enable()
				} else {
					console.warn('Plugin cordova backgroundMode non caricato')
				}

				if(self.plugins.intentShim) {
					console.debug('[DeviceProvider.platform.ready()] Plugin intenShim caricato')

					//registra handler nuovi intent
					self.plugins.intentShim.onIntent(intent => {
						console.log('[DeviceProvider.plugins.webintent.onNewIntent()] Nuovo intent:', intent)
						self.events.publish(DomainEvents.INTENT_RECEIVED, intent)
					})

					//verifica l'intent attuale (primo caricamento)
					self.plugins.intentShim.getIntent(intent => {
						console.info("[DeviceProvider.plugins.webintent.onNewIntent()] Intent al primo caricamento:", intent)
						self.events.publish(DomainEvents.INTENT_RECEIVED, intent)
					}, error => {
						console.error("Errore recuperando l'intent attuale", error)
					})
				} else {
					console.warn('Plugin cordova intenShim non disponibile')
				}

				/*
				if (self.plugins.webintent) {
				console.debug('Plugin webintent caricato')

				self.plugins.webintent.onNewIntent(uri => {
				if (uri !== '') {
				// `uri` is the uri that was passed to onNewIntent
				console.log('[DeviceProvider.plugins.webintent.onNewIntent()] Nuovo Intent con URI: ' + uri)
				} else {
				console.log('[DeviceProvider.plugins.webintent.onNewIntent()] Nuovo Intent senza URI')
				}
				});

				self.plugins.webintent.getUri(uri => {
				if (uri !== '') {
				// `uri` is the uri that was passed to onNewIntent
				console.log('[DeviceProvider.plugins.webintent.getUri()] invocato con URI: ' + uri)
				} else {
				console.log('[DeviceProvider.plugins.webintent.getUri()] invocato senza URI')
				}
				// `uri` is the uri the intent was launched with.
				//
				// If this is the first run after the app was installed via a link with an install referrer
				// (e.g. https://play.google.com/store/apps/details?id=com.example.app&referrer=referrer.com)
				// then the Play Store will have fired an INSTALL_REFERRER intent that this plugin handles,
				// and `uri` will contain the referrer value ("referrer.com" in the example above).
				// ref: https://help.tune.com/marketing-console/how-google-play-install-referrer-works/
				});
				}
				*/
			}


			console.debug('[DeviceProvider.platform.ready()] : Caricamento della configurazione dispositivo..')
			//caricamento iniziale configurazione
			self.getActual(null, DeviceCache.FALLBACK).then((_: Device) => {
				console.debug('[DeviceProvider.platform.ready()] : Primo caricamento della configurazione dispositivo eseguito.')
			}).catch(error => {
				console.error('Errore durante la prima lettura della configurazione del dispositivo locale', error)
			})
			//ricaricamento periodico
			self.enableActualPolling()

			console.groupEnd()
		})
	}

	/**
	Imposta l'avvio automatico, attivo in background e sempre in primo piano in funzione della configurazione del dispositivo e dello stato di autenticazione

	Va invocato al cambio configurazione del dispositivo, al login e al logout
	*/
	public adaptBehaviour() {
		console.group('[DeviceProvider.adaptBehaviour()] Aggiornamento del comportamento in base a tipo di dispositivo e stato di autenticazione')

		let actual = DeviceProvider.actual
		let actualType = this.actualType
		let alwaysOnFrontMode = actual && actual.always_on_front_mode ? actual.always_on_front_mode : 'auto'
		let isAlwaysOnFrontAuto = alwaysOnFrontMode == 'auto'

		//modo sempre in primo piano forzato
		if(!isAlwaysOnFrontAuto) {
			this._isAlwaysFront = (alwaysOnFrontMode == 'enabled')//non automatico: Attiva o non attiva esplicitamente
		}

		//configurazione avvio automatico
		switch(actualType) {
			case DeviceType.INTERCOM:
			case DeviceType.DASHBOARD:
				//autostart
				if(this.isCordova) {
					if(this.autostart) this.autostart.enable()
					//attivo in background
					if(this.plugins.backgroundMode) {
						//this.plugins.backgroundMode.enable()
						//no background mode su citofono e bacheca, altrimenti resta la notifica, l'andamento in background è prevenuto in altro modo
						this.plugins.backgroundMode.disable()
					}
				}

				if(isAlwaysOnFrontAuto) {//primo piano automatico su bacheca o citofono: Attivo
					this._isAlwaysFront = true
				}
				break
			case DeviceType.SMARTPHONE:
				if(this.isCordova) {
					if(alwaysOnFrontMode == 'enabled' || this.auth.isAuth) {//primo piano forzato o utente autenticato: Avvio automatico e attivo in background
						//autostart
						if(this.autostart) this.autostart.enable()
						//attivo in background
						if(this.plugins.backgroundMode) this.plugins.backgroundMode.enable()
					} else {//non autenticato ne primo piano esplicito, avvio manuale e standby in background

						//avvio manuale
						if(this.autostart) this.autostart.disable()
						//standby in background
						if(this.plugins.backgroundMode) this.plugins.backgroundMode.disable()
					}
				}

				if(isAlwaysOnFrontAuto) {//primo piano automatico su cell: Non attivo
					this._isAlwaysFront = false
				}
				break
			case DeviceType.BROWSER:
				break
		}

		console.groupEnd()
	}

	public androidSend(data: { action: string; message?: string; [k: string]: any }): any {
		return this.androidBridge.send(data);
	}

       public call_native(number: string, ringTimeout: number = 20, talkTimeout: number = 60): Promise<any> {
               console.debug('[DeviceProvider.call_native()] Inoltro la richiesta di chiamata nativa', number, ringTimeout, talkTimeout)
               if(number==null||number===''){
                       return Promise.reject('Numero chiamata diretta non impostato')
               }
               return new Promise<any>((resolve, reject) => {
                       try {
                               let result = this.androidBridge.send_call(number, ringTimeout, talkTimeout)
                               resolve(result)
                       } catch(e) {
                               console.error('[DeviceProvider.call_native()] Errore inviando la chiamata', e)
                               reject(e)
                       }
               })
       }
        public close_app() {
                return this.androidBridge.send_close_app()
        }

        /**
        * Sends an impulse to open the door. Uses the native Android bridge when
        * running on an Android device. On other platforms it simply resolves
        * without performing any native action.
        */
        public openDoor(): Promise<any> {
                if (this.platform.is('android')) {
                        return this.androidBridge.send_impulse()
                }

                console.warn('[DeviceProvider.openDoor()] send_impulse not available on this platform')
                return Promise.resolve()
        }


	/**
	Richiede i permessi per mic e/o cam
	*/
	public askCallPermissions(): Promise<boolean> {
		return this.requestPermissions([this.androidPermissions.PERMISSION.CALL_PHONE])
	}

	/**
	Richiede i permessi per mic e/o cam
	*/
	public askMediaPermissions(askAudio: boolean, askVideo: boolean): Promise<boolean> {
		let permissions: string[] = []
		if(askAudio) {
			permissions.push(this.androidPermissions.PERMISSION.RECORD_AUDIO)
			permissions.push(this.androidPermissions.PERMISSION.MODIFY_AUDIO_SETTINGS)
		}
		if(askVideo) {
			permissions.push(this.androidPermissions.PERMISSION.CAMERA)
		}
		return this.requestPermissions(permissions)
	}

	/**
	Avvia la chiamata
	*/
	/*
	public call(number: string, bypassAppChooser: boolean = true): Promise<boolean> {
	if (!this.isCallNumberAvailable) {
	return Promise.resolve(false)
	}

	return new Promise<boolean>((resolve, reject) => {
	window.plugins.CallNumber.callNumber(
	(success) => {
	console.debug('Effettuata chiamata numero:' + number, success)
	resolve(true)
	}, (error) => {
	console.error('Errore avviando la chiamata telefonica al numero:' + number, error)
	reject('Errore avviando la chiamata telefonica')
	},
	number,
	bypassAppChooser)
	})
	}
	*/

	/**
	Elimina la configurazione attuale da cache e storage
	*/
	private clearActual(): Promise<any> {
		return this.setActual(null)
	}

	/**
	Elimina la configurazione di un dispositivo.
	Se il dispositivo coincide con quello attuale imposta il dispositivo attuale a null ed elimina il backup dallo storage
	*/
	public destroy(device: Device): Promise<boolean> {
		console.log("Eliminazione della configurazione del dispositivo")

		let self = this
		return new Promise<boolean>((resolve, _) => {
			let request = this.http.post(ConfigProvider.HOST + "/device/" + device.id + "/destroy", { confirm: true })
			request.subscribe(
				deleted => {
					if(!deleted) {//Chiamata ok ma non ha trovato il dispositivo
						console.warn("Configurazione del dispositivo non trovata: " + device)
						resolve(false)
						return
					}
					console.log("Configurazione del dispositivo eliminata")
					if(self.isActual(device)) {
						console.log("Si è eliminato il dispositivo corrente, impostazione del dispositivo corrente a null e propagazione dell'evento corrispondente")
						self.clearActual()
					}

					resolve(true)
				}, error => {
					console.error("Errore eliminando la configurazione del dispositivo: ", error)
					//reject(error);
					resolve(false)
				}
			)
		})
	}


	/**
	Disabilita l'eventuale timeout di ricaricamento configurazione corrente
	*/
	public disableActualPolling() {
		if(this.refreshActualInterval) {
			clearTimeout(this.refreshActualInterval)
			console.debug('Rimosso il precedente timeout di polling configurazione dispositivo.')
		}
	}



	/**
	(re)imposta il timeout per ricaricare il dispositivo attuale, e ne forza un ricaricamento
	*/
	public enableActualPolling() {
		//eventuale rimozione del precedente timer
		this.disableActualPolling()

		let refreshSeconds: number
		switch(this.actualType) {//tipo attuale
			case DeviceType.BROWSER:
				refreshSeconds = ConfigProvider.TIMEOUT_DEVICE_ACTUAL_REFRESH_DEFAULT
				break
			case DeviceType.SMARTPHONE:
				refreshSeconds = ConfigProvider.TIMEOUT_DEVICE_ACTUAL_REFRESH_DEFAULT
				break
			case DeviceType.DASHBOARD:
				refreshSeconds = ConfigProvider.TIMEOUT_DEVICE_ACTUAL_REFRESH_DASHBOARD
				break
			case DeviceType.INTERCOM:
				refreshSeconds = ConfigProvider.TIMEOUT_DEVICE_ACTUAL_REFRESH_INTERCOM
				break
			default:
				refreshSeconds = ConfigProvider.TIMEOUT_DEVICE_ACTUAL_REFRESH_DEFAULT
				break
		}
		console.debug('[DeviceProvider.enableActualPolling()] Impostazione del pollingo configurazione dispositivo corrente ogni ' + refreshSeconds + ' secondi..')

		let self = this
		self.refreshActualInterval = setInterval(() => {
			console.group('[DeviceProvider.refreshActualInterval] Polling: Refresh della configurazione del dispositivo attuale..')
			this.getActual(null, DeviceCache.REMOTE).then(device => {
				console.debug('[DeviceProvider.refreshActualInterval] Configurazione dispositivo attuale ricaricata', device)
				console.groupEnd()
			}).catch(e => {
				console.warn('Errore durante il refresh periodico della configurazione dispositivo attuale', e)
				console.groupEnd()
			})
		}, refreshSeconds * 1000)
	}

	/**
	Verifica il supporto dei dispositivi di input
	Restituisce true SSE ha almeno un dispositivo di input disponibile
	*/
	public enumerateDevices(): Promise<boolean> {
		console.debug('Elenco dei dispositivi di input..')
		let self = this
		if(!navigator.mediaDevices && !navigator.mediaDevices.getUserMedia) {
			self.isAudioInputSupported = false
			self.isVideoInputSupported = false
			self.isAudioOutputSupported = false
			console.warn('Impossibile effettuare chiamate WebRTC su questo browser, getUserMedia() non supportato')
			return Promise.reject('Impossibile effettuare chiamate su questo dispositivo o browser, elenco dei dispositivi di input non supportato')
		}


		return new Promise((resolve, reject) => {
			self.isAudioInputSupported = false
			self.isVideoInputSupported = false
			self.isAudioOutputSupported = false

			self.askMediaPermissions(true, true).then(() => {
				let checks: Promise<any>[] = []

				checks.push(navigator.mediaDevices.enumerateDevices().then((devices) => {
					devices.forEach((device) => {
						switch(device.kind) {
							case "audioinput":
								self.isAudioInputSupported = true
								break
							case "videoinput":
								self.isVideoInputSupported = true
								break
							case "audiooutput":
								self.isAudioOutputSupported = true
								break
						}
					})
				}))

				Promise.all(checks).then(() => {
					resolve(self.isAudioInputSupported || self.isVideoInputSupported)
				}).catch(function(err) {
					console.error("Errore verificando ai dispositivi di I/O del dispositivo", err)
					reject(err)
				})
			})
		})
	}

	/*
	Genera un UUID senza plugin nativi
	*/
	public generateIdentifier() {
		let h4 = () => {
			return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
		}
		let uuid = h4() + h4() + '-' + h4() + '-' + h4() + '-' + h4() + '-' + h4() + h4() + h4()
		console.log("UUID random generato: " + uuid)
		return uuid
	}

	/**
	Responsabilità: Carica i dati del dispositivo dal server remoto.

	@param cacheMode Può usare opzionalmente la cache: ALL prova prima a cercare in cache; NONE: Non usa la cache neanche in caso di errore; FALLBACK usa la cache solo se ha errore di connessione

	*/
	public getActual(
		loads: string[] = null,
		cacheMode: DeviceCache = DeviceCache.ALL
	): Promise<Device> {
		if(loads === null) {
			loads = ['condominium', 'condominium.contacts', 'condominium.messages']
		}

		let self = this

		return new Promise<Device>((resolve, reject) => {
			if(cacheMode == DeviceCache.ALL || cacheMode == DeviceCache.CACHED) {//usa la cache per prima o esclusivamente
				console.log('Ricerca in cache della configurazione dispositivo corrente attiva..')

				if(DeviceProvider.actual) {
					console.log('Configurazione dispositivo corrente trovata in cache')
					resolve(DeviceProvider.actual)
					return
				}
				console.debug('Configurazione dispositivo corrente non trovata in cache')

				//prima di proseguire verifica se è presente nello storage
				self.storage.get(StorageKeys.DEVICE_ACTUAL).then(deviceJson => {
					if(deviceJson) {
						console.log('Configurazione dispositivo corrente presente nello storage, nessun caricamento')
						let device = JSON.parse(deviceJson)
						resolve(device)
						return
					}
					console.log('Configurazione dispositivo corrente non trovata nello storage')

					if(cacheMode == DeviceCache.CACHED) {
						resolve(null)
					} else {
						//altrimenti stessa chiamata ma ignorando la cache
						return self.getActual(loads, DeviceCache.REMOTE).catch((e) => {
							console.error('Errore recuperando la configurazione da remoto', e)
						})
					}
				}).catch(error => {
					console.error('Errore cercando la configurazione del dispositivo corrente nello storage', error)
					if(cacheMode == DeviceCache.CACHED) {
						reject('Errore cercando la configurazione del dispositivo corrente nello storage')
					} else {
						//altrimenti stessa chiamata ma ignorando la cache
						return self.getActual(loads, DeviceCache.REMOTE).then(() => {
						}).catch((e) => {
							console.error('Errore recuperando la configurazione da remoto', e)
						})
					}
				})
			} else {//usa il remote per primo o esclusivamente
				console.debug('Recupero configurazione dispositivo corrente ignorando cache e storage')

				self.getIdentifier().then((identifier: string) => {//Recupera o genera identifier
					console.debug('Recupero dei dati del dispositivo da identifier: ' + identifier)

					self.getByIdentifier(identifier, loads).then((actual: Device) => {//Carica per identifier
						if(!actual) {
							console.warn("Dispositivo non associato lato server: " + identifier)
							self.clearActual().then(() => {
								resolve(null)
								console.groupEnd()
								return
							}).catch(e => {
								console.error('Errore recuperando la configurazionde del dispositivo attuale da cache e storage', e)
								console.groupEnd()
								reject('Errore recuperando la configurazionde del dispositivo attuale da cache e storage')
							})
						}

						console.log("Configurazione del dispositivo attuale caricata: ", actual)
						resolve(actual)
						console.groupEnd()
					}).catch(error => {
						if(cacheMode == DeviceCache.FALLBACK) {
							console.warn('Caricamento della configurazione del dispositivo attuale fallita, provo a riusare la configurazione in cache o nello storage', error)
							return self.getActual(loads, DeviceCache.CACHED).then(() => {
								console.groupEnd()
							}).catch((e) => {
								console.error('Errore recuperando la configurazione dalla cache', e)
								console.groupEnd()
							})
						} else {
							console.error('Errore caricando la configurazione del dispositivo da identifier', error)
							reject(error)
							console.groupEnd()
						}
					})
				}).catch(error => {
					console.error('Errore recuperando l\'identifier corrente', error)
					console.groupEnd()
					reject(error)
				})
			}
		})
	}

	/*
	Recupera i dati del dispositivo da remoto, per id
	*/
	public getById(
		id: number,
		loads: string[] = ['condominium'],
		params: HttpParams = new HttpParams()
	): Promise<Device> {
		if(loads && loads.length > 0) {//aggiunge eventuali relazioni da caricare

			for(let load of loads) {
				params = params.append('load[]', load)
			}
		}
		let self = this

		let request = this.http.get(ConfigProvider.HOST + '/device/' + id, { params: params })

		return new Promise<Device>((resolve, reject) => {
			request.subscribe(
				device => {
					if(!device) {//Chiamata ok ma non ha trovato il dispositivo
						console.warn("Dispositivo non trovato tramite id: " + id)
						reject("Dispositivo non trovato tramite id: " + id)
						return
					}
					console.log("Dispositivo trovato tramite id: " + id, device)

					self.init(<Device>device).then(() => {
						console.debug('[DeviceProvider.getById()] Dispositivo inizializzato')
						resolve(<Device>device)
					})
				}, error => {
					console.error("Impossibile recuperare il dispositivo tramite chiave: " + id, error)
					//reject(error);
					resolve(null)
				}
			)
		})
		//return this.indexDevice(ConfigProvider.HOST+'/device','GET',params);
	}

	/**
	Recupera i dati del dispositivo da remoto, per identificativo, eseguendo init()
	*/
	public getByIdentifier(
		identifier: string,
		loads: string[] = ['condominium']
	): Promise<Device> {
		let self = this
		let params = new HttpParams()

		for(let load of loads) {
			params = params.append('load[]', load)
		}

		let request = this.http.get(ConfigProvider.HOST + '/device/identifier/' + identifier, { params: params })

		return new Promise<Device>((resolve, reject) => {
			request.subscribe(
				(device: Device) => {
					if(!device) {//Chiamata ok ma non ha trovato il dispositivo
						console.warn("Dispositivo non trovato tramite identificatore unico: " + identifier)
						resolve(null)
						//reject("Dispositivo non trovato tramite identificatore unico: "+identifier);
						return
					}
					console.debug("[DeviceProvider.getByIdentifier('" + identifier + "')] Configurazione dispositivo trovata tramite identificatore unico:", device)

					self.init(device).then(() => {
						resolve(device)
					})
				}, error => {
					console.warn("Impossibile recuperare il dispositivo tramite identificatore unico '" + identifier + "': " + error.message, error)
					reject(error)
					//resolve(null);
				}
			)
		})
		//return this.indexDevice(ConfigProvider.HOST+'/device','GET',params);
	}

	/*
	Restituisce il tipo di autenticazione di default in base al tipo del dispositivo corrente
	*/
	getDefaultAuthType(): AccountType {
		switch(this.actualType) {
			case DeviceType.INTERCOM:
				console.info('[DeviceProvider.getDefaultAuthType] INTERCOM: Modalità login: PIN')
				return AccountType.PIN
			case DeviceType.SMARTPHONE:
				console.info('[DeviceProvider.getDefaultAuthType] SMARTPHONE: Modalità login: PIN')
				return AccountType.PIN
			case DeviceType.DASHBOARD:
				console.info('[DeviceProvider.getDefaultAuthType] DASHBOARD: Modalità login: PIN')
				return AccountType.PIN
			case DeviceType.BROWSER:
				console.info('[DeviceProvider.getDefaultAuthType] BROWSER: Modalità login: EMAIL_PASSWORD')
				return AccountType.EMAIL_PASSWORD
		}
	}

	/**
	Recupera l'identificativo device, se non è disponibile ne genera uno
	*/
	public getIdentifier(): Promise<string> {
		console.group("[DeviceProvider.getIdentifier()] Recupero identificativo del dispoistivo corrente...")
		let self = this
		return new Promise<string>((resolve, reject) => {
			//1 già in memoria
			if(DeviceProvider.identifier) {//già caricato
				console.debug('[DeviceProvider.getIdentifier()] Identifier già inizializzato:', DeviceProvider.identifier)
				resolve(DeviceProvider.identifier)
				console.groupEnd()
				return
			}

			// 2) dai parametri pagina (querystring + hash SPA)
			console.debug('[DeviceProvider.getIdentifier()] cerco device_id nei parametri URL');

			const query_params = new URLSearchParams(window.location.search || '');
			const hash_str = window.location.hash || '';
			const hash_params = new URLSearchParams(hash_str.includes('?') ? hash_str.slice(hash_str.indexOf('?')) : '');

			const device_id = query_params.get('device_id') || query_params.get('device-id') || hash_params.get('device_id') || hash_params.get('device-id');

			if (device_id && device_id.trim()) {
				const cleaned = device_id.trim();
				console.debug('[DeviceProvider.getIdentifier()] trovato device_id nei parametri:', cleaned)
				self.setIdentifier(cleaned)
				resolve(cleaned)
				console.groupEnd()
				return
			}

			//3 da storage
			self.storage.get(StorageKeys.DEVICE_IDENTIFIER)
				.then(
					identifier => {
						if(identifier) {
							console.debug('[DeviceProvider.getIdentifier()] Trovato identifier persistito: ' + identifier)
							self.setIdentifier(identifier)
							resolve(identifier)
							console.groupEnd()
							return
						}

					
						//4 UUID browser
						console.debug('[DeviceProvider.getIdentifier()] Nessun identifier persistito nè da android bridge, generazione nuovo identifier..')
						identifier = self.device.uuid
						if(identifier) {
							console.debug('[DeviceProvider.getIdentifier()] Trovato UUID device: ' + identifier)
							self.setIdentifier(identifier)
							resolve(identifier)
							console.groupEnd()
							return
						}

						//5 casuale generato
						console.debug('[DeviceProvider.getIdentifier()] Nessun UUID device (browser), tento con uniqueDeviceID..')
						self.uniqueDeviceID.get().then((uuid: string) => {
							if(uuid) {
								console.debug('[DeviceProvider.getIdentifier()] Trovato uniqueDeviceUUID: ' + uuid)
								self.setIdentifier(uuid)
								resolve(uuid)
								console.groupEnd()
								return
							}
							console.debug('[DeviceProvider.getIdentifier()] Nessun uniqueDeviceID (browser), genero un valore pseudocasuale..')
							identifier = self.generateIdentifier()
							self.setIdentifier(identifier)
							resolve(identifier)
							console.groupEnd()
							return
						}).catch((error: any) => {
							console.error("Errore generando uniqueDeviceID: ", error)
							console.debug('[DeviceProvider.getIdentifier()] Impossibile recuperare uniqueDeviceID, genero un valore pseudocasuale..')
							identifier = self.generateIdentifier()
							self.setIdentifier(identifier)
							resolve(identifier)
							console.groupEnd()
						})
					},
					error => {
						console.error("Errore recuperando l'UUID persistito", error)
						reject(error)
						console.groupEnd()
					}
				)
		})
	}

	/**
	Recupera gli input media stream occupandosi di richiedere i permessi on demand.
	Se sonoi richiesti input non disponibili nel dispositivo li ignora.


	TODO quale camera scegliere

	video: { facingMode: ("user" | "environment") }
	*/
	public getUserMedia(audio: any, video: any): Promise<MediaStream> {
		/*
		Android 26 and above: due to Android 26's changes to permissions handling (permissions are requested at time of use rather than at runtime,) if your app does not include any functions (eg. other Ionic Native plugins) that utilize a particular permission, then requestPermission() and requestPermissions() will resolve immediately with no prompt shown to the user. Thus, you must include a function utilizing the feature you would like to use before requesting permission for it.
		*/
		return new Promise<MediaStream>((success, fail) => {
			if(!audio && !video) {
				fail("[DeviceProvider.getUserMedia()] E' necessario richiedere almeno uno stream input audio o video")
			}

			let askAudio = audio && this.isAudioInputSupported
			let askVideo = video && this.isVideoInputSupported

			let self = this

			/*
			//Primo tentativo per verificare i permessi
			navigator.mediaDevices.getUserMedia({
			video: askVideo ? video : false,
			audio: askAudio ? audio : false
		}).then((stream: MediaStream) => {
		console.log('[DeviceProvider.getUserMedia()] Input media stream recuperati senza chiedere i permessi.');
		//Ok, restituisco i media
		success(stream);
	}).catch(function(err) {
	console.log('[DeviceProvider.getUserMedia()] Errore recuperando gli input media stream, provo a chiedere i permessi:', err.name, err.message);
	*/
			self.askMediaPermissions(askAudio, askVideo).then(() => {
				console.log('[DeviceProvider.getUserMedia()] Permessi richiesti, riprovo a recuperare gli input media stream..')
				navigator.mediaDevices.getUserMedia({
					video: askVideo ? video : false,
					audio: askAudio ? audio : false
				}).then((stream: MediaStream) => {
					console.log('[DeviceProvider.getUserMedia()] Input media stream ottenuti', stream)
					//Ok, restituisco i media
					success(stream)
				}).catch((err) => {
					//Errore defvinitivo anche con i permessi
					console.error('[DeviceProvider.getUserMedia()] Impossibile ottenere i media input stream anche dopo aver chiesto i permessi:', err.name, err.message, err)

					switch(err.name) {
						case "NotAllowedError":
							err.details = "Per attivare le chiamate devi concedere a questa app l'accesso ai dispositivi"
							break
						case "AbortError":
							err.details = "Impossibile accedere ad uno o più dispositivi di input"
							break
						case "NotFoundError":
							err.details = "Impossibile trovare il tipo di dispositivo di input richiesto"
							break
						case "NotReadableError":
							err.details = "Impossibile ricevere input dal dispositivo"
							break
						case "OverconstrainedError":
							err.details = "Impossibile soddisfare i requisiti con questo dispositivo"
							break
						case "OverconstrainedError":
							err.details = "Impossibile soddisfare i requisiti con questo dispositivo"
							break
						case "SecurityError":
							err.details = "Il tuo sistema non consente l'accesso al dispositivo"
							break
						case "TypeError":
							err.details = "Nessun dispositivo adeguato disponibile"
							break
						default:
							err.details = "Errore sconosciuto"
							break
					}
					console.error(err.details, err)
					fail(err)
				})
			})
			/*
			}).catch((err) => {
			console.log('Errore richiedendo i permessi per gli input media input stream:', err.name, err.message);
			});
			*/
		})
	}


	/**
	In base ai dati che ha cerca di capire che tipo di dispositivo è
	*/
	public guessType(): DeviceType {
		if(!this.isBrowser) {//App
			//console.log("Configurazione più probabile: Smartphone");
			return DeviceType.SMARTPHONE
		} else {//Altrimenti browser generico
			//console.log("Configurazione più probabile: Browser");
			return DeviceType.BROWSER
		}
	}

	/*
	Elenca i dispositivi, eventualmente filtrandoli per condominio
	FIXME quando aggiorna l'elenco dispositivi se aggiorna l'attuale rimanda alla root. Modificare in modo che avvenga solo se necessario (es. se cambia il tipo di dispositivo)
	*/
	public index(
		condominium: Condominium = null,
		loads: Array<string> = [],
		types: Array<string> = undefined,
		term: string = null
	): Promise<Array<Device>> {
		let self = this
		let params = new HttpParams()
		//.append('with_condominium',with_condominium?'1':'0')
		//.append('with_condominium_contacts',with_condominium_contacts?'1':'0')
		//.append('with_condominium_messages',with_condominium_messages?'1':'0');
		for(let load of loads) {
			params = params.append('load[]', load)
		}

		if(types) {
			params = params.append('types', JSON.stringify(types))
		}
		if(condominium) {
			params = params.append('condominium_id', '' + condominium.id)
		}
		if(term) {
			params = params.append('terms', term)
		}

		let request = this.http.get<Array<Device>>(ConfigProvider.HOST + '/device', { params: params })

		return new Promise<Device[]>((resolve, reject) => {
			request.subscribe(devices => {
				//Chiamata ok ma non ha trovato l'utente
				if(!devices) {
					console.warn("Dispositivi non trovati")
					reject(devices)
					return
				}
				if(params.get('condominium_id')) {
					console.log("Elenco dispositivi del condominio " + params.get('condominium_id'), devices)
				} else {
					console.log("Elenco dispositivi recuperati", devices)
				}

				for(let i = 0; i < devices.length; i++) {
					self.init(devices[i])
				}
				resolve(devices)
			}, error => {
				if(params.get('condominium_id')) {
					console.log("Errore recuperando i  dispositivi del condominio " + params.get('condominium_id'), error)
				} else {
					console.log("Errore recuperando i  dispositivi", error)
				}

				reject(error)
			}
			)
		})
	}

	/**
	Inizializza i dati del dispositivo dopo averli letti da remoto.

	Se il dispositivo corrisponde al corrente aggiorna cache e storage
	*/
	private init(device: Device): Promise<boolean> {
		console.debug("[DevicePRovider.init()] Inizializzazione configurazione dispositivo:", device)
		let self = this

		return new Promise((resolve, reject) => {
			self.getIdentifier().then(_ => {
				if(self.isActual(device)) {//se è quello corrente produce gli aggiornamenti opportuni
					let previous = DeviceProvider.actual
					console.debug('[DeviceProvider.init()] Inizializzata la configurazione del dispositivo corrente, configurazione sostituita:', previous)

					if(!previous || !self.isEqual(previous, device)/*device.updated_at==self.actual.updated_at*/) {//è cambiato qualcosa
						console.debug("Trovata configurazione aggiornata del dispositivo corrente, salvo in storage e propago l'evento..")

						self.setActual(device).then(_ => resolve(true))
					} else {//già aggiornato
						resolve(true)
					}
				} else {
					console.log('Inizializzazione configurazione altro dispositivo')
					resolve(false)//non era quello locale
				}
			}).catch(e => {
				console.error('Errore recuperando l\'identificativo del dispositivo corrente', e)
				reject('Errore recuperando l\'identificativo del dispositivo corrente' + e)
			})
		})
	}


	/**
	verifica se la configurazione dispositivo passata è quella del dispositovo corrente,
	basandosi sull'identifier
	*/
	private isActual(device: Device): boolean {
		if(!DeviceProvider.identifier || !device) return false//impossibile verificare
		return DeviceProvider.identifier == device.identifier//identificazione basata su identifier
	}

	private isEqual(self: any, other: any) {
		if(self === other) return true
		// if both x and y are null or undefined and exactly the same

		if(!(self instanceof Object) || !(other instanceof Object)) return false
		// if they are not strictly equal, they both need to be Objects

		if(self.constructor !== other.constructor) return false
		// they must have the exact same prototype chain, the closest we can do is
		// test there constructor.

		for(var p in self) {
			if(!self.hasOwnProperty(p)) continue
			// other properties were tested using x.constructor === y.constructor

			if(!other.hasOwnProperty(p)) return false
			// allows to compare x[ p ] and y[ p ] when set to undefined

			if(self[p] === other[p]) continue
			// if they have the same strict value or identity then they are equal

			if(typeof (self[p]) !== "object") return false
			// Numbers, Strings, Functions, Booleans must be strictly equal

			if(!this.isEqual(self[p], other[p])) return false
			// Objects and Arrays must be tested recursively
		}

		for(p in other) {
			if(other.hasOwnProperty(p) && !self.hasOwnProperty(p)) return false
			// allows x[ p ] to be set to undefined
		}
		return true
	}

	public isAuthRequired() {
		switch(this.actualType) {
			case DeviceType.INTERCOM:
				return false
			case DeviceType.SMARTPHONE:
				return true
			case DeviceType.DASHBOARD:
				return false
			case DeviceType.BROWSER:
				return true
		}
	}

	/**
	Manda l'app in background

	NON funziona se è attiva la modalità isAlwaysFront
	*/
	public moveToBackground() {
		console.debug('[DeviceProvider.moveToBackground()] Richiesta di andare in background..')

		if(this.isBrowser) {
			console.debug('Browser: Funzionalità manda in background ignorata')
			return
		}

		if(this.isAlwaysFront) {
			console.warn('[DeviceProvider.moveToBackground()]: Sempre in primo piano, richiesta di mandare in background ignorata')
			return
		}
		//Disabilita il foreground forzato
		//self.isAlwaysFront = false

		this.plugins.backgroundMode.moveToBackground()
	}

	/**
	Porta l'app in primo piano.

	Se lo schermo è spento o bloccato lo sblocca e attiva
	*/
	public moveToForeground() {
		if(this.isBrowser) {
			console.debug('[DeviceProvider.moveToForeground()] Browser: Funzionalità "porta in primo piano" ignorata')
			return
		}

		if(!this.plugins.backgroundMode) {
			console.warn('[DeviceProvider.moveToForeground()] Plugin backgroundMode non disponibile')
			return
		}

		if(this.plugins.backgroundMode.isActive()) {
			console.debug('[DeviceProvider.moveToForeground()] Applicazione in background, riporto in primo piano..')
			this.plugins.backgroundMode.moveToForeground()
		}


		try {
			/*
			isScreenOff non disponibile in backgroundMode in quanto non rilasciato nella versione attuale.
			Forzare l'installazione non è compatibile con la versione attuale di cordova/android

			https://github.com/katzer/cordova-plugin-background-mode/issues/303#issuecomment-418451498
			*/
			if(this.plugins.backgroundMode.isScreenOff) {
				this.plugins.backgroundMode.isScreenOff((isScreenOff) => {
					if(isScreenOff) {
						console.debug('Accendo lo schermo spento..')
						if(this.plugins.backgroundMode.wakeUp) {
							this.plugins.backgroundMode.wakeUp()
						}
						/*
						INTERAZIONE A SCHERMO BLOCCATO DISABILITATA
						console.debug('Rimuovo eventuale blocco schermo..');
						if (this.plugins.backgroundMode.unlock) {
						this.plugins.backgroundMode.unlock()
					}
					*/
					}
				})
			} else {
				if(this.plugins.backgroundMode.wakeUp) {
					this.plugins.backgroundMode.wakeUp()
				}
				/*
				INTERAZIONE A SCHERMO BLOCCATO DISABILITATA
				if (this.plugins.backgroundMode.unlock) {
				this.plugins.backgroundMode.unlock()
			}
			*/
			}
		} catch(e) {
			console.error('Errore usando il plugin backgroundMode', e)
		}
	}


	/*
	Associa un dispositivo ad un condominio
	lavora con identifier dispositivo e modello condominio
	*/
	public register(deviceIdentifier: string, condominiumId: number): Promise<Device> {
		//let self = this;
		return new Promise<Device>((resolve, reject) => {
			let params = { condominium_id: condominiumId }
			let request = this.http.post(ConfigProvider.HOST + '/device/identifier/' + deviceIdentifier + '/register', params)
			request.subscribe(
				(device: Device) => {
					if(!device) {//Chiamata ok ma non ha trovato il dato
						console.warn("Dispositivo non trovato")
						reject('Dispositivo non trovato')
						return
					}

					console.log("Dispositivo registrato", device)
					this.init(device)

					resolve(device)
				}, error => {
					console.error("Errore registrando il dispositivo", error)

					reject(error)
				}
			)
		})
	}

	/**
	Richiede i permessi

	le stringhe coi nomi permessi sono costanti in this.androidPermissions.PERMISSION
	es.: this.androidPermissions.PERMISSION.CAMERA, this.androidPermissions.PERMISSION.RECORD_AUDIO
	*/
	public requestPermissions(requiredPermissions: string | string[]): Promise<boolean> {
		console.group('[DeviceProvider.requestPermissions()] Verifico i permessi sul dispositivo', requiredPermissions)

		return new Promise<boolean>((success, _) => {
			if(this.isBrowser) {
				console.log('Browser: Richiesta permessi ignorata')

				console.groupEnd()
				success(true)
				return
			}

			//conversione in array forzata
			if(!(requiredPermissions instanceof Array)) {
				requiredPermissions = [requiredPermissions]
			}

			//permessi da richiedere
			let lackingPermissions: string[] = []
			//promise controllo permessi
			let checkingPermissions: Promise<void>[] = []

			for(let requiredPermission of requiredPermissions) {
				checkingPermissions.push(new Promise<void>((resolve, _) => {
					this.androidPermissions.checkPermission(requiredPermission).then(
						(result: any) => {
							console.debug('[DeviceProvider.requestPermissions()] Permesso "' + requiredPermission + '": ', result)
							if(!result.hasPermission) {
								lackingPermissions.push(requiredPermission)
							}
							resolve()
						},
						error => {
							console.warn('[DeviceProvider.requestPermissions()] Errore verificando il permesso "' + requiredPermission + '":', error)
							lackingPermissions.push(requiredPermission)
							resolve()
						}
					)
				}))
			}

			console.log("Promise controllo permessi: ", checkingPermissions.length)

			if(checkingPermissions.length == 0) {
				console.log('Nessun permesso mancante, richiesta soddisfatta.')
				console.groupEnd()
				success(true)
				return
			}


			Promise.all(checkingPermissions).then((results: any[]) => {
				console.log('Terminata la verifica dei permessi già ottenuti, mancanti:', lackingPermissions, results)

				if(lackingPermissions.length > 0) {
					this.androidPermissions.requestPermissions(lackingPermissions).then(result => {
						console.log('Permessi richiesti, risultato:', result)
						console.groupEnd()
						success(true)
					})
				} else {
					console.log('Permessi già presenti, nessuna richiesta.')
					console.groupEnd()
					success(true)
				}
			}).catch(error => {
				console.error('Errore non previsto richiedendo i permessi: ' + error.message, error)
				console.groupEnd()
				success(false)
			})
		})
	}

	/*
	cancella e rigenera l'identifier, ricaricando i dati del dispositivo
	*/
	public resetIdentifier(): Promise<string> {
		this.clearActual()
		DeviceProvider.identifier = null
		let self = this

		return new Promise<string>((resolve, reject) => {
			self.storage.set(StorageKeys.DEVICE_IDENTIFIER, null).then(() => {
				self.getActual().then((actual: Device) => {
					if(!actual) {
						console.warn("Dispositivo non associato lato server")
						resolve(DeviceProvider.identifier)
						return
					}
					resolve(actual.identifier)
				}).catch(error => {
					console.error("Errore reinizializzando il dispositivo attuale")
					reject(error)
				})
			}).catch(error => {
				console.error("Errore cancellando l'identifier dallo storage")
				reject(error)
			})
		})
	}

	private async setActual(device: Device): Promise<Device> {
		console.debug('[DeviceProvider.setActual()] Impostazione del device corrente',device)
		let self = this
		let previous = DeviceProvider._actual
		let previousType = DeviceProvider._actualType

		DeviceProvider._actual = device
		if(device) {
			DeviceProvider._actualIdentifier = device.identifier
		} else {
			DeviceProvider._actualIdentifier = null
			console.debug('[DeviceProvider.setActual()] Rimozione del dispositivo attuale')
		}
		console.debug('[DeviceProvider.setActual()] Identificativo del dispositivo corrente: ',DeviceProvider._actualIdentifier)

		let actualType = device ? device.type : null

		if(!actualType) {
			actualType = this.guessType()
			console.debug("Il dispositivo non è registrato, il tipo è stato determinato in modo euristico: " + actualType)
		}

		window.appContext.device = device ? { ...device } : { note: 'guessed' }
		if(window.appContext.device.condominium) {
			delete window.appContext.device.condominium//elimina i riferimenti per il log
		}

		//aggiorna i comportamenti correlati alla configurazione
		this.adaptBehaviour()

		//TODO Spostare la logica qui sotto in adaptBehaviour
		if(actualType != previousType) {//cambio tipo
			console.group('[DeviceProvider.setActual()] Modificato il tipo del dispositivo attuale da "' + previousType + '" a: "' + actualType + '"')

			DeviceProvider._actualType = actualType
			window.appContext.device.type = actualType

			try {
				switch(actualType) {//tipo attuale
					case DeviceType.BROWSER://no cordova, no fullscreen ecc..
						break
					case DeviceType.SMARTPHONE://cordova ma no kiosk
						self.togglePortait(true)

						//schermo può spegnersi
						self.toggleKeepawake(false)
						break
					case DeviceType.DASHBOARD://controllo messaggi + KIOSK
					case DeviceType.INTERCOM://KIOSK


						//schermo sempre acceso
						self.toggleKeepawake(true)

						//fisso in primo piano
						self.toggleFullscreen(true)

						//autohide navigation bar
						//viene usata l'opzione in settings display
						//self.toggleNavigationBarAutohide(true);

						if(actualType == DeviceType.DASHBOARD) {
							//schermo orizzontale
							self.toggleLandscape(true)
						} else {
							//schermo verticale
							self.togglePortait(true)
						}
						break
					default:
						console.warn("Tipo dispositivo non riconosciuto: " + actualType)
						break
				}
			} catch(e) {
				console.error('Errore configurando il tipo dispositivo', e, e.message, e.stack)
			}
		}


		let persist: Promise<Device>
		if(device) {
			persist = this.storage.set(StorageKeys.DEVICE_ACTUAL, JSON.stringify(device))
		} else {//rimozione
			persist = this.storage.remove(StorageKeys.DEVICE_ACTUAL)
		}

		//inizializza i _iceServers, bloccante
		await this.initIceServers()

		//infine persiste, emette gli eventi di avvenuto aggiornamento e ritorna
		return new Promise<Device>((resolve, reject) => {
			persist.then((result) => {
				console.debug('[DeviceProvider.setActual()] Modifiche alla configurazione dispositivo persistite', result)


				console.group('[DeviceProvider.setActual()] Tipo del dispositivo cambiato, propago l\'evento')
				self.events.publish(DomainEvents.DEVICE_ACTUAL_UPDATED, DeviceProvider.actual, Date.now(), previous)//Evento di avvenuto aggiornamento dispositivo corrente
				console.groupEnd()

				/*
				if (actualType != previousType) {
				console.group('[DeviceProvider.setActual()] Tipo del dispositivo cambiato, propago l\'evento')
				self.events.publish(DomainEvents.DEVICE_ACTUAL_TYPE_UPDATED, actualType, previousType);//Evento di avvenuto aggiornamento del tipo dispositivo corrente
				console.groupEnd()
			}
			*/

				resolve(previous)
			}).catch(e => {
				console.error('Errore persistendo o cancellando la configurazione del dispositivo', e)
				reject('Errore persistendo o cancellando la configurazione del dispositivo')
			})
		})
	}


	/**
	Imposta l'identifier in memoria e sullo storage, aggiorna la copia persistita e propaga l'evento
	*/
	private setIdentifier(identifier: string) {
		console.debug("[DeviceProvider.setIdentifier()] Identifier del dispoistivo corrente: " + identifier)
		DeviceProvider.identifier = identifier//Salva il campo
		this.storage.set(StorageKeys.DEVICE_IDENTIFIER, identifier)//Persiste
		this.events.publish(DomainEvents.DEVICE_ACTUAL_IDENTIFIED, identifier, Date.now())//Evento di avvenuta identificazione
	}


	/**
	Avvia un'app esterna

	url: url da passare
	type: tipo mime
	package: package
	class: classe dell'activity
	*/
	public startActivity(url: string = null, type: string = null, pkg: string = null, cls: string = null): Promise<boolean> {
		let self = this

		if(!this.plugins.intentShim) {
			return Promise.reject('Plugin intent non disponibile')
		}

		return new Promise((resolve, reject) => {

			let intent: any = {
				action: self.plugins.intentShim.ACTION_VIEW,
			}
			if(type) {
				intent.type = type
			}
			if(url) {
				intent.url = url
			}
			if(cls || pkg) {
				intent.component = {}
				if(cls) {
					intent.component.class = cls
				}
				if(pkg) {
					intent.component.package = pkg
				}
			}

			self.plugins.intentShim.startActivity(intent, () => {
				console.debug('[DeviceProvider.startActivity()] Avviata activity')
				resolve(true)
			}, (e) => {
				console.error('Errore aprendo la URL via Android Intent. URL=' + url + '; TYPE=' + type + '; PACKAGE=' + pkg + '; CLASS=' + cls, e)
				reject("Errore avviando l'app esterna")
			})
		})
	}

	/**
	SOLO ANDROID

	Avvia un'activity tramite intent e aspetta il risultato

	Se la richiesta è ok e restituisce il risultato, resolve al momento del risultato restituendo l'intent

	Se la richiesta fallisce, reject

	Se resultTimeoutMS!=[0,null,false] e la richiesta non risolve entro resultTimeoutMS, reject
	*/
	public startActivityForResult(action: string, url: string = null, resultTimeoutMS = 300000): Promise<any> {
		if(!this.plugins.intentShim) {
			return Promise.reject('Plugin intent non disponibile')
		}

		let requestCode = new Date().getTime() % 1000000//evitiamo cifre troppo alte per un int

		return new Promise((resolve, reject) => {
			let actionTimeout = setTimeout(() => {
				reject("Nessuna risposta entro il termine prestabilito di " + (resultTimeoutMS / 1000) + " secondi")
			}, resultTimeoutMS)

			this.plugins.intentShim.startActivityForResult(
				{
					action: action,
					url: url,
					requestCode: requestCode
				},
				intent => {
					//blocco il timeout risposta
					clearTimeout(actionTimeout)

					console.debug("[DeviceProvider.startActivityForResult()] Ricevuto intent di risposta", intent)

					if(intent.extras.requestCode != requestCode) {
						console.warn("[DeviceProvider.startActivityForResult()] Request code diverso da quello inviato: " + intent.extras.requestCode + "!=" + requestCode)
					}

					resolve(intent)
				},
				() => {
					console.log("Errore avviando l'intent")
					//blocco il timeout risposta
					clearTimeout(actionTimeout)
					reject("Errore avviando l'applicazione esterna")
				})
		})
	}

	public startService(pkg: string, cls: string, url: string = null) {
		let self = this

		if(!self.plugins.intentShim) {
			console.warn('Plugin intentShim non disponibile')
			return Promise.reject('Plugin intentShim non disponibile')
		}

		return new Promise((resolve, reject) => {

			let intentOptions: any = {
				action: self.plugins.intentShim.ACTION_VIEW,
				component: {
					package: pkg,
					class: cls
				}
			}
			if(url) {
				intentOptions.url = url
			}

			self.plugins.intentShim.startService(intentOptions, () => {
				console.debug('[DeviceProvider.startService()] Avviato servizio')
				resolve(true)
			}, (e) => {
				console.error('Errore aprendo la URL via Android Intent. URL: ' + url, pkg, e)
				reject("Errore avviando l'app esterna")
			})
		})
	}


	/**
	Crea una configurazione remota per il dispositivo con l'identificatore attuale se non ancora presente, altrimenti non fa nulla
	*/
	public storeActual(): Promise<Device> {
		console.group('[DeviceProvider.storeActual()] : Creazione di una nuova configurazione del dispositivo locale')
		let self = this

		return new Promise<Device>((resolve, reject) => {
			self.getActual([], DeviceCache.REMOTE).then(actual => {
				if(actual) {
					console.warn('Si è tentato di creare una configurazione per un dispositivo con configurazione già esistente', actual)
					console.groupEnd()
					resolve(actual)
					return
				}

				self.getIdentifier().then((identifier: string) => {
					console.log('Identificatore locale recuperato: ' + identifier)

					if(!identifier) {
						console.warn('Impossibile recuperare l\'identificatore del dispositivo corrente')
						console.groupEnd()
						reject('Impossibile recuperare l\'identificatore del dispositivo corrente')
						return
					}

					let params = new HttpParams().set('type', self.actualType).set('identifier', identifier)
					this.http.post<Device>(ConfigProvider.HOST + '/device/store', params).subscribe(
						device => {
							if(!device) {//Chiamata ok ma non ha creato la configurazione
								console.warn("Configurazione dispositivo non creata")
								console.groupEnd()
								reject("Configurazione dispositivo non creata")
							} else {
								console.log("Configurazione dispositivo creata:", device)

								self.init(device).then(() => {
									console.groupEnd()
									resolve(device)
								}).catch(e => {
									console.error('Errore inizializzando il dispositivo corrente con la nuova configurazione', e)
									console.groupEnd()
									resolve(device)
								})
							}
						}, error => {
							console.error("Errore verificando l\'esistenza della configurazione del dispositivo", error)
							console.groupEnd()
							reject(error)
						})
				}).catch(error => {
					console.error("Errore recuperando l'identificativo del dispositivo corrente", error)
					console.groupEnd()
					reject(error)
				})
			}).catch(error => {
				console.error('Errore recuperando la configurazione del dispositivo corrente', error)
				console.groupEnd()
				reject(error)
			})
		})
	}


	public toggleFullscreen(active: boolean = null) {
		console.info('[DeviceProvider.toggleFullscreen(' + (active === null ? "null" : (active ? "true" : "false")) + ')]')
		let self = this
		if(active === null) {
			this._isFullScreen = !this._isFullScreen
		} else {
			this._isFullScreen = active
		}

		if(this.isBrowser) {
			console.log('Browser: Funzionalità schermo intero ignorata')
			return
		}

		/*
		FULLSCREEN
		*/
		this.androidFullScreen.isImmersiveModeSupported().then(() => {
			console.log('[DeviceProvider.toggleFullscreen()] Immersive mode supportato (pieno schermo)')
			if(this._isFullScreen) {
				console.log('DeviceProvider.toggleFullscreen(): Entro in modalità pieno schermo..')
				self.androidFullScreen.immersiveMode()
			} else {
				console.log('DeviceProvider.toggleFullscreen(): Visualizzo system UI..')
				self.androidFullScreen.showSystemUI()
			}
		}).catch(err => console.error('Errore andando in modalità fullscreen:', err))
	}


	public toggleNavigationBarAutohide(active: boolean = null) {
		console.log('DeviceProvider.toggleNavigationBarAutohide(' + (active === null ? "null" : (active ? "true" : "false")) + ')..')
		if(active === null) {
			this._isNavigationBarAutohiding = !this._isNavigationBarAutohiding
		} else {
			this._isNavigationBarAutohiding = active
		}

		if(this.isBrowser) {
			console.log('Browser: Funzionalità nascondi barre di navigazione ignorata')
			return
		}

		console.log('Visualizzo system UI..')
		this.navigationBar.setUp(this._isNavigationBarAutohiding).then(() => {
			console.log('DeviceProvider.navigationBar.setUp(..): Visibilità barra di navigazione configurata.')
		}).catch(err => console.error('Errore nascondendo la barra di navigazione:', err))
	}

	public toggleKeepawake(active: boolean = null) {
		console.log('DeviceProvider.toggleKeepawake(' + (active === null ? "null" : (active ? "true" : "false")) + ')..')
		if(active === null) {
			this._isKeepawake = !this._isKeepawake
		} else if(active !== this._isKeepawake) {
			this._isKeepawake = active
		}

		if(this.isBrowser) {
			console.log('Browser: Funzionalità mantieni schermo acceso ignorata')
			return
		}


		if(this._isKeepawake) {
			console.info('[DeviceProvider.toggleKeepawake(true)] Insomnia manterrà l\'app sempre attiva')
			this.insomnia.keepAwake()
				.then(
					() => console.log('Insomnia success'),
					() => console.log('Insomnia error')
				)
		} else {
			console.info('[DeviceProvider.toggleKeepawake(false)] Insomnia consentirà all\'app di andare in standby')
			this.insomnia.allowSleepAgain()
				.then(
					() => console.log('Sleep success'),
					() => console.log('Sleep error')
				)
		}
	}



	/**
	Imposta o cambia l'orientamento orizontale forzato
	*/
	public toggleLandscape(active: boolean = null) {
		console.log('DeviceProvider.toggleLandscape(' + (active === null ? "null" : (active ? "true" : "false")) + ')..')
		if(active === null) {
			this._isLanscape = !this._isLanscape
		} else {
			this._isLanscape = active
		}

		if(this.isBrowser) {
			console.log('Browser: Funzionalità schermo orizzontale')
			return
		}


		if(this._isLanscape) {
			this.togglePortait(false)//se è orizzontale non è verticale
		}

		if(this.guessType() == DeviceType.BROWSER) {//nessuna azione per i browser
			return
		}

		if(this._isLanscape) {
			console.log('Lock orientamento schermo, orientamento attuale:', this.screenOrientation.type)
			this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE)
		} else if(!this._isPortrait) {
			console.log('Unlock orientamento schermo, orientamento attuale:', this.screenOrientation.type)
			this.screenOrientation.unlock()
		}
	}

	/**
	Imposta o cambia l'orientamento verticale forzato
	*/
	public togglePortait(active: boolean = null) {
		console.log('DeviceProvider.togglePortait(' + (active === null ? "null" : (active ? "true" : "false")) + ')..')
		if(active === null) {
			this._isPortrait = !this._isPortrait
		} else {
			this._isPortrait = active
		}

		if(this._isPortrait) {
			this.toggleLandscape(false)//se è verticale non è orizzontale
		}

		if(this.isBrowser) {
			console.log('Browser: Funzionalità schermo verticale ignorata')
			return
		}

		if(this._isPortrait) {
			console.log('Lock orientamento schermo, orientamento attuale:', this.screenOrientation.type)
			this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT)
		} else if(!this._isLanscape) {
			console.log('Unlock orientamento schermo, orientamento attuale:', this.screenOrientation.type)
			this.screenOrientation.unlock()
		}
	}

	/*
	Aggiorna la configurazione di un dispositivo
	*/
	public update(device: Device) {
		let self = this
		return new Promise<Device>((resolve, reject) => {
			let request = this.http.post<Device>(ConfigProvider.HOST + '/device/' + device.id + '/update', device)
			request.subscribe(
				(device: Device) => {
					if(!device) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Configurazione dispositivo non recuperata dopo il salvataggio")
						reject("Configurazione dispositivo non recuperata dopo il salvataggio")
						return
					}
					console.log("Configurazione dispositivo salvata")

					//Inizializza il dispositivo riletto
					self.init(device)
					//self.actual=device;
					resolve(device)
				}, error => {
					console.error("Errore salvando la configurazione del dispositivo", error)
					reject(error)
				}
			)
		})
	}
}



// WEBPACK FOOTER //
// ./src/providers/device/device.ts